// deveverAjax.js

const defaultOption = {
    url: "",
    type: "GET",
    data: null,
    username: null,
    password: null,
    processData: true,
    contentType: "application/x-www-form-urlencoded",
    dataType: "json",
    showLoader: true,
    customHeader: null,
    loaderTimeInMs: 2000,
    error: function () {
        if (typeof globalNotyf !== "undefined" && globalNotyf) {
            globalNotyf.error(window.unknownErrorText || "Error");
        }
    }
};

function serialize(obj, prefix) {
    const out = [];
    for (let p in obj) {
        if (!obj.hasOwnProperty(p)) continue;
        const key = prefix ? `${prefix}[${p}]` : p;
        const val = obj[p];
        const part = (val !== null && typeof val === "object")
            ? serialize(val, key)
            : `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
        out.push(part);
    }
    return out.join("&");
}

function deveverAjax(optionFromUser = {}) {
    const option = Object.assign({}, defaultOption, optionFromUser);

    let xhr = new XMLHttpRequest();
    let loadTimeout = null;
    let isWaiting = true;

    if (!option) return;

    // Loader
    if (option.showLoader) {
        loadTimeout = setTimeout(() => {
            const loader = document.querySelector("#ajax_loading_div");
            if (loader) loader.style.display = "block";
            isWaiting = false;
        }, option.loaderTimeInMs);
    }

    // beforeSend
    if (option.beforeSend) option.beforeSend();

    // GET + data -> query string
    if (option.data && option.processData && option.type === "GET" && typeof option.data !== "string") {
        const qs = serialize(option.data);
        option.url += (option.url.includes("?") ? "&" : "?") + qs;
        option.data = null;
    }

    // Open request
    xhr.open(
        option.type,
        option.url,
        true,
        option.username ?? null,
        option.username ? option.password ?? null : null
    );

    // Headers for POST/PUT/DELETE
    if (option.data && option.processData && typeof option.data !== "string" && ["POST", "PUT", "DELETE"].includes(option.type)) {
        if (option.contentType === "multipart/form-data") {
            const fd = new FormData();
            for (const prop in option.data) fd.append(prop, option.data[prop]);
            option.data = fd;
        } else {
            option.data = JSON.stringify(option.data);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        }
    } else if (option.contentType && typeof option.contentType === "string") {
        xhr.setRequestHeader("Content-Type", option.contentType);
    }

    // Custom headers
    if (option.customHeader) {
        const headers = Array.isArray(option.customHeader)
            ? option.customHeader
            : [option.customHeader];
        headers.forEach(h => xhr.setRequestHeader(h.key, h.value.toString()));
    }

    // Response type
    if (option.dataType) xhr.responseType = option.dataType;

    // Onload
    xhr.onload = (event) => {
        const res = event.target.response;
        if (xhr.status >= 200 && xhr.status < 400) {
            option.success?.(res, event);
        } else {
            option.error?.(res, event);
        }
        stopLoader();
    };

    // Onprogress
    if (option.progress) {
        xhr.onprogress = (event) => {
            const res = event.target.response;
            option.progress?.(res, event);
        };
    }

    // Onerror
    xhr.onerror = (event) => {
        const res = event.target.response;
        option.error?.(res, event);
        stopLoader();
    };

    // Send
    xhr.send(option.data ?? null);

    // Stop loader
    function stopLoader() {
        if (option.showLoader) {
            if (isWaiting) clearTimeout(loadTimeout);
            else {
                const loader = document.querySelector("#ajax_loading_div");
                if (loader) loader.style.display = "none";
            }
        }
    }
}

export { deveverAjax, defaultOption };
